export const unleashConfig = {
  url: process.env.NEXT_PUBLIC_UNLEASH_URL ?? "UNLEASH_URL",
  clientKey: process.env.NEXT_PUBLIC_UNLEASH_CLIENT_KEY ?? "CLIENT_KEY",
  refreshInterval: 15,
  appName: process.env.NEXT_PUBLIC_UNLEASH_APP_NAME ?? "APP_NAME",
};
